'use strict';

var OldWSConnection = require('../transports/old-websocket');


module.exports = function (client) {

    client.transports['old-websocket'] = OldWSConnection;
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/oldwebsocket.js
// module id = 547
// module chunks = 2